<template>
  <el-dialog
          title="规格编辑"
          :visible.sync="dialogVisible"
          append-to-body
          @opened="dialogOpen"
  >
    <el-form
            ref="form"
            :model="form"
            label-width="100px"
            size="small"
    >
      <el-form-item
              prop="rule_name"
              label="规格名称"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.rule_name"></el-input>
      </el-form-item>

      <el-form-item
              prop="remarks"
              label="备注"
      >
        <el-input v-model="form.remarks"></el-input>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
                type="primary"
                :loading="loading"
                @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>

import * as userService from '@/api/sys/user'; import * as agentService from '@/api/sys/agent'
import util from '@/libs/util.js'
export default {
  name: 'editspeakerForm',
  props: {
    agent: Object,
    accuseVisible: Boolean,
    store_id: Number,
    value: Boolean
  },
  data () {
    return {
      formEdit: true,
      accuseVisible2: true,
      loading: false,
      dialogVisible: false,
      form: {
        state: '0',
        voice_state: '1'
      }

    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
      console.log('--value---' + val)
    },
    accuseVisible (newValue, oldValue) {
      console.log('-----' + newValue)
      this.accuseVisible2 = newValue
    },

    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()

      if (this.agent.id) {
        // userService.getUser(this.user.id).then(data => {
        let form = {}
        form.rule_name = this.agent.rule_name
        form.remarks = this.agent.remarks

        this.form = form
        // });
        this.formEdit = this.accuseVisible2
      } else {
        this.formEdit = this.accuseVisible2
        let form = {}
        form.state = '0'
        form.voice_state = '1'
        this.form = form
      }
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          agentService.saveAgentStoreRule({ ...this.form, agentid: util.cookies.get('agentid'), id: this.agent.id, type_id: this.store_id })
            .then(data => {
              this.loading = false
              this.dialogVisible = false
              this.$emit('submit')
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
